import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { UserCredentials } from '../../../store/authentication/model/user-credentials.model';
import { Observable } from 'rxjs';
import { ErrorCode } from '../../../models/error-code.model';

import { AuthenticationFacade } from '../../../store/authentication/authentication.facade';
import { CustomizationFacade } from '../../../store/customization/customization.facade';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
    signInForm: FormGroup = new FormGroup({
        email: new FormControl(''),
        password: new FormControl('')
    });

    signInError$: Observable<ErrorCode | null> = new Observable<ErrorCode>();
    customizations$ = this.customizationFacade.customization$;

    constructor(
        private authenticationFacade: AuthenticationFacade,
        private customizationFacade: CustomizationFacade
    ) {}

    ngOnInit() {
        this.signInForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', Validators.required)
        });

        this.signInError$ = this.authenticationFacade.signInError$;
    }

    // getter
    get email() {
        return this.signInForm.get('email');
    }

    get password() {
        return this.signInForm.get('password');
    }

    submitLogin() {
        const credentials: UserCredentials = {
            email: this.email?.value,
            password: this.password?.value,
            storeCredentials: true
        };

        this.authenticationFacade.signIn(credentials);
    }
}
